export default __webpack_public_path__ + "static/media/competition.d3b0d9ae.png";